<svg viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M1.5 10L5 13.5L14 1.5" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
